import { cn } from '@/lib/utils';
import { PageHeader } from './page-header';

interface PageLayoutProps {
  /** Title passed through to PageHeader. Omit (and use `header`) for full control. */
  title?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  mono?: boolean;
  /** Escape hatch: supply a custom header node instead of the title/description/actions props. */
  header?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

// Inner page scaffold: a PageHeader on top and content below, with consistent
// vertical rhythm. Deliberately adds NO outer page padding — AppLayout's
// `<main className="p-6">` owns that, so PageLayout never double-pads.
export function PageLayout({
  title,
  description,
  actions,
  mono,
  header,
  children,
  className,
}: PageLayoutProps) {
  const resolvedHeader =
    header ??
    (title != null ? (
      <PageHeader title={title} description={description} actions={actions} mono={mono} />
    ) : null);

  return (
    <div className={cn('space-y-6', className)}>
      {resolvedHeader}
      <div>{children}</div>
    </div>
  );
}
